module.exports = __webpack_public_path__ + "bv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bv.svg
// module id = 470
// module chunks = 0